import { defineComponent, onMounted, onUnmounted, ref, nextTick } from 'vue';
export default defineComponent({
  name: 'SwiperHeader',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup: function (props, _a) {
    var emit = _a.emit;
    var list = props.list;
    var autoRef = ref(true);
    var onClickItem = function (item, index) {
      autoRef.value = false;
      list.forEach(function (i) {
        return i.active = i.activityTypeName === item.activityTypeName;
      });
      emit('change', index);
    };
    var slideTo = function (index) {
      if (list[index].active) return;
      autoRef.value = false;
      list.forEach(function (_, i) {
        return _.active = i === index;
      });
    };
    var timer;
    function autoPlay() {
      if (!autoRef.value) {
        return;
      }
      var len = list.length;
      for (var i = 0; i < len; i++) {
        if (list[i].active) {
          list[i].active = false;
          var currentIndex = (i + 1) % len;
          list[currentIndex].active = true;
          emit('change', currentIndex);
          break;
        }
      }
      timer = setTimeout(autoPlay, 5000);
    }
    onMounted(function () {
      nextTick(function () {
        list[0].active = true;
      });
      timer = setTimeout(autoPlay, 5000);
    });
    onUnmounted(function () {
      clearTimeout(timer);
    });
    return {
      autoRef: autoRef,
      list: list,
      onClickItem: onClickItem,
      slideTo: slideTo
    };
  }
});